import reduce from 'lodash/reduce';

var Constants = [];

const constantObject = reduce(
    Constants,
    (accumulator, value) => {
        accumulator[value] = value;
        return accumulator;
    },
    {}
);

export default constantObject;
